import { render } from "./Hero.vue?vue&type=template&id=5a4bab0d&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=5a4bab0d&lang=scss&scoped=true"

import exportComponent from "/Users/josue/Documents/projects/wwv/dapp/werewolfvalley/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4bab0d"]])

export default __exports__